import { getView, requireAuth } from 'Lib/utils';
import { Left } from 'Models/Menu/menus';
import { OrganizationCreatePage } from '@/data/appInformationItems';

export default {
  path: 'organizations/create',
  name: 'createNewOrganization',
  component: getView('pages/PageOrganizationEdit'),
  beforeEnter: requireAuth,
  meta: {
    crumbs: 'Organizations > Create New',
    leftMenu: Left.OrganizationsList,
    roles: ['operator'],
    information: OrganizationCreatePage,
    showBottomMenu: true,
  },
};
